import React from 'react';
import { devErrorOnce, generateUniqueKey } from '../../../utils';
import RibbonMenuGroup from './Custom/RibbonMenuGroup';
import RibbonButton from './RibbonButton';
import RibbonNullButton from './RibbonNullButton';
import styles from './RibbonButtonGroup.module.scss';
import NullButton from '../../Commands/NullButton';

export default (props: IRibbonButtonGroupProps) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const buttons = props.buttons.map((x: any, i: number) => {
        if (Array.isArray(x)) {
            if (
                x.length == 2 &&
                typeof x[0] === 'object' &&
                !Array.isArray(x[0]) &&
                Array.isArray(x[1])
            ) {
                return (
                    <RibbonMenuGroup
                        key={generateUniqueKey('rbnGroup-rbnMenuGroup', i)}
                        button={x[0]}
                        menu={x[1]}
                    />
                );
            }
            return x;
        }
        if (x.config === undefined) {
            return x;
        }
        if (x.config instanceof NullButton) {
            return (
                <RibbonNullButton
                    key={generateUniqueKey('groupNullBtn', i)}
                    config={x.config}
                    size={x.size}
                />
            );
        }
        return (
            <RibbonButton key={generateUniqueKey('groupBtn', i)} config={x.config} size={x.size} />
        );
    });
    const buttonGroups: Array<JSX.Element[]> = [];
    for (let i = 0; i < buttons.length; i += 3) {
        buttonGroups.push(buttons.slice(i, i + 3));
    }

    return (
        <>
            {buttonGroups.map((x: JSX.Element[], i: number) => (
                <div key={generateUniqueKey('btnGroup', i)} className={styles.btnGroup}>
                    {x}
                </div>
            ))}
        </>
    );
};

interface IRibbonButtonGroupProps {
    // TODO: Data Type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    buttons: any[];
}
